import { isFetchTracker, type Task } from "types/Task";
import { shouldStopPolling, getTaskKind } from "types/TaskRegistry";

/**
 * Counts non-terminal tasks for the sidebar badge.
 *
 * `mcp-task` rows are additionally gated on `liveConfirmed`, so one counts only
 * once a poll has confirmed it active this session. Their persisted status can
 * be stale-active forever: nothing refreshes it server-side, so a task that
 * finished while unobserved (tab closed, or poll budget exhausted) keeps
 * arriving non-terminal on every later reload, and without the gate the badge
 * would count it permanently with nothing able to clear it. See `liveConfirmed`
 * in `types/Task.ts`. Long-task rows PATCH their terminal status durably, so
 * their hydrated status is authoritative and they count immediately.
 */
export function countActiveTasks(tasks: Task[]): number {
  return tasks.filter(
    (task) =>
      // Fetch trackers are invisible to the user, so counting them would be
      // confusing: the badge would report a job the Tasks popup never lists.
      !isFetchTracker(task) &&
      !shouldStopPolling(task.status) &&
      !task.dismissed &&
      (getTaskKind(task) !== "mcp-task" || task.liveConfirmed)
  ).length;
}
